const generateInterventionGroupValues = (referenceMap) => {
    if (referenceMap?.populationReference && referenceMap.interventionDescriptionReference) {
        return {
            "combinationMethod": "all-of",
            "characteristic": [
                {
                    "description": "inclusion in " + referenceMap.populationReference.display,
                    "code": { "text": "Member of" },
                    "valueReference": referenceMap.populationReference,
                    "exclude": false
                },
                {
                    "description": "exposed to " + referenceMap.interventionDescriptionReference.display,
                    "code": { "text": "Exposed to" },
                    "valueReference": referenceMap.interventionDescriptionReference,
                    "exclude": false
                }
            ]
        }
    }
};

export default generateInterventionGroupValues;